<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.demanda.titulo')}}</v-card-title>

        <v-row>
          <!-- Inlacion anual -->
          <v-col cols="2" sm="2">
            <v-text-field
            :disabled="this.disabled"
              density="compact"  
              variant="outlined"                       
              :label="$t('simulacion.modulo.ejecucion.TASA_INFL')"
              v-model="INFL_formatted"
              :rules="[]"
              :min="0"
                                     
            ></v-text-field>
          </v-col>
          <v-col>
            
          </v-col>
        </v-row>
          <v-row>
          <!-- Precios iniciales de  -->
           <!-- inflacion:0,
            pr_H2VOb:4,
            pr_H2VOp:4,
            pr_H2LOb:4,
            pr_H2LOp:4, -->
          <v-col cols ="4" >
            <v-text-field
            :disabled="this.disabled"
              density="compact"  
              variant="outlined"                       
              :label="$t('simulacion.modulo.demanda.H2VOb')"
              v-model.number="this.local_infl.pr_H2VOb"
              type="number"
              :rules="[rules.Negativo]"                        
            ></v-text-field>
            <v-text-field
              density="compact"  
              variant="outlined"                       
              :label="$t('simulacion.modulo.demanda.H2LOb')"
              v-model.number="this.local_infl.pr_H2LOb"
              type="number"
              :rules="[rules.Negativo]"        
              :disabled="this.opc_mcdo==3 || this.disabled"                
            ></v-text-field>
            
            <v-btn :disabled="this.disabled" color="primary" class="mb-2" @click="calcularInflacion">
              {{$t('simulacion.modulo.demanda.aplicar_inflacion')}} 
            </v-btn>
          </v-col>

          <v-col cols="4">
            <v-text-field
              density="compact"  
              variant="outlined"                       
              :label="$t('simulacion.modulo.demanda.H2VOp')"
              v-model.number="this.local_infl.pr_H2VOp"
              type="number"
              :rules="[rules.Negativo]"             
              :disabled="this.disabled"           
            ></v-text-field>
            

            <v-text-field
              density="compact"  
              variant="outlined"                       
              :label="$t('simulacion.modulo.demanda.H2LOp')"
              v-model.number="this.local_infl.pr_H2LOp"
              type="number"
              :rules="[rules.Negativo]"
              :disabled="this.opc_mcdo==3 || this.disabled"                        
            ></v-text-field>
          </v-col>

         

        </v-row>

        
        <v-divider></v-divider>
        <v-card-text>
          <v-card-title>{{$t('simulacion.modulo.demanda.subtitulo')}}</v-card-title>
            <v-row>

              
              <v-col cols="12" class="d-flex justify-end mb-2">
                <v-btn  color="primary" class="mx-2" @click="exportToCSV">
                  {{$t('comun.boton_exportar')}} {{$t('simulacion.modulo.demanda.subtitulo')}}
                </v-btn>
                
                <v-btn :disabled="this.disabled" color="primary" class="mx-2" @click="importFromCSV">
                  {{$t('comun.boton_importar')}} {{$t('simulacion.modulo.demanda.subtitulo')}}
                  <input
                    type="file"
                    accept=".csv"
                    ref="fileInput"
                    style="display: none;"
                    @change="handleCSVUpload"
                  />
                </v-btn>
              </v-col>
              


            <v-col cols="12">
                <!-- <v-container class="contenedor-porcentaje">
                  <v-row>      
                    <v-col cols=12>
                      <div id="app2">
                          <v-grid 
                          theme="material" 
                          :source="modelValue" 
                          :columns="columns"
                          canFocus=true
                            range=true
                            useClipboard=true
                            readonly=false
                            filter=true
                            resize=true    
                            @afteredit="handleCellEdit"                        
                          ></v-grid>      
                      </div>
                    </v-col>      
                  </v-row>
                </v-container> -->
                <div class="tabla-container scroll-container">
                  <table class="tabla-estilizada">
                    <thead>
                      <tr>
                        <th v-for="col in this.columns" :key="col.prop" :style="{ width: col.size + 'px' }">
                          {{ col.name }}
                        </th>
                      </tr>
                    </thead>
                        <tbody>
                <tr
                  v-for="(fila, index) in modelValue.filter(d => {
                     const partes = d.id.split('-');
                    const anio = parseInt(partes[0]);
                    let mes = parseInt(partes[1]);
                    //Si no existe el mes en las partes separadas, se asigna a 1 para que el modo anual funcione tambien
                    
                    const anioInicio = datos_generales.anio_inicio;
                    const anioFin = datos_generales.anio_fin;
                    const mesInicio = datos_generales.mes_inicio;
                   
                    // Filtra por año dentro del rango
                    if (anio < anioInicio || anio > anioFin) return false;
                    
                    if (mes){
                      
                      // Si es el primer año, aplica también el filtro de mes
                      if (anio === anioInicio && mes < mesInicio) return false;
                      
                      // Si es el último año, aplica el filtro del mes a la inversa
                      if (anioInicio!=anioFin &&  anio === anioFin && ( mesInicio!=1 && mes >= mesInicio)) {
                        console.log('ANIO ', anio ,' AnioInicio: ->', anioInicio, ' anioFin ',anioFin , ' mes', mes)
                        return false;}
                    }
                    return true;
                  })"
                  :key="index"
                >
                  <td>{{ fila.id }}</td>

                  <td>
                    <input
                      :disabled="this.disabled"
                      type="text"
                      :value="formatNumber(fila.dH2VOb)"
                      @input="event => {
                        const val = event.target.value.replace(',', '.');
                        fila.dH2VOb = Number(val);
                        validarCampo(fila, 'dH2VOb');
                      }"
                      class="campo"
                    />
                  </td>

                  <td>
                    <input
                      :disabled="this.disabled"
                      type="text"
                      :value="formatNumber(fila.pcH2VOb)"
                      @input="event => {
                        const val = event.target.value.replace(',', '.');
                        fila.pcH2VOb = Number(val);
                        validarCampo(fila, 'pcH2VOb');
                      }"
                      class="campo"
                    />
                  </td>

                  <td>
                    <input
                      :disabled="this.disabled"
                      type="text"
                      :value="formatNumber(fila.dH2VOp)"
                      @input="event => {
                        const val = event.target.value.replace(',', '.');
                        fila.dH2VOp = Number(val);
                        validarCampo(fila, 'dH2VOp');
                      }"
                      class="campo"
                    />
                  </td>

                  <td>
                    <input
                      :disabled="this.disabled"
                      type="text"
                      :value="formatNumber(fila.pcH2VOp)"
                      @input="event => {
                        const val = event.target.value.replace(',', '.');
                        fila.pcH2VOp = Number(val);
                        validarCampo(fila, 'pcH2VOp');
                      }"
                      class="campo"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      </v-row>

      <!-- Tabla DEMANDA_LC -->
      <v-divider class="ma-5" thickness="5"></v-divider>

      <v-card-title>{{ $t('simulacion.modulo.demanda_lc.subtitulo') }}</v-card-title>

      <v-row>
        <v-col cols="4" class="d-flex mb-2">

          <div v-if="this.ejecucion && 'OPC_LCOHLC' in this.ejecucion &&  this.name =='Anual'">
                   <!-- {{ opc_lcohlc }}
                   {{ opc_lcohlc ? "Es cierto" : "No lo es" }} -->
                   <v-switch
                   :disabled="this.id"
                        v-model="opc_lcohlc"
                        :label=" $t('simulacion.modulo.demanda.OPC_LCOHLC_desactivado') "
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                        :true-value="0"
                        :false-value="1"  
                         
                      />
                      <!-- @change="handleSwitchChange" -->
                      <!-- $t('simulacion.modulo.demanda.OPC_LCOHLC_desactivado') -->
                       <!-- @change="this.local_ejecucion.opc_lcohlc ? onActivar() : onDesactivar()" -->
                  </div>
        </v-col>
        <v-col cols="2">

        </v-col>
        <v-col cols="6" class="d-flex justify-end mb-2">
          <v-btn
            color="primary"
            class="mx-2"
            @click="exportToCSVLC"
            :disabled="this.opc_mcdo==3"
          >
            {{ $t('comun.boton_exportar') }} {{ $t('simulacion.modulo.demanda_lc.subtitulo') }}
          </v-btn>

          <v-btn
            color="primary"
            class="mx-2"
            @click="importFromCSVLC"
            :disabled="this.opc_mcdo ==3 || this.disabled"
          >
            {{ $t('comun.boton_importar') }} {{ $t('simulacion.modulo.demanda_lc.subtitulo') }}
            <input
              type="file"
              accept=".csv"
              ref="fileInputLC"
              style="display: none;"
              @change="handleCSVUploadLC"
            />
          </v-btn>
        </v-col>

        <v-col cols="12" class="d-flex justify-start mt-4">
          <v-alert
            v-if="opc_mcdo==3"
            type="error"
            dense
            outlined
            class="error-alert"
          >
            <span v-html="$t('simulacion.modulo.demanda.alerta')"></span>
          </v-alert>
        </v-col>

        <v-col cols="12">
          <div class="tabla-container scroll-container">
            <table class="tabla-estilizada">
              <thead>
                <tr>
                  <th v-for="col in this.columns_lc" :key="col.prop" :style="{ width: col.size + 'px' }">
                    {{ col.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(fila, index) in demanda_lc.filter(d => {
                      const partes = d.id.split('-');
                    const anio = parseInt(partes[0]);
                    let mes = parseInt(partes[1]);
                    //Si no existe el mes en las partes separadas, se asigna a 1 para que el modo anual funcione tambien
                    
                    const anioInicio = datos_generales.anio_inicio;
                    const anioFin = datos_generales.anio_fin;
                    const mesInicio = datos_generales.mes_inicio;

                    // Filtra por año dentro del rango
                    if (anio < anioInicio || anio > anioFin) return false;
                    if (mes){
                      // Si es el primer año, aplica también el filtro de mes
                      if (anio === anioInicio && mes < mesInicio) return false;
                      
                      // Si es el último año, aplica el filtro del mes a la inversa
                      if (anioInicio!=anioFin &&  anio === anioFin && ( mesInicio!=1 && mes >= mesInicio)) return false;
                    }
                    return true;
                  })"
                  :key="index"
                >
                  <td>{{ fila.id }}</td>

                  <td>
                    <input
                      type="text"
                      :disabled="opc_mcdo ==3 || disabled"
                      :value="formatNumber(fila.dH2VOb)"
                      @input="event => {
                        const val = event.target.value.replace(',', '.');
                        fila.dH2VOb = Number(val);
                        validarCampo(fila, 'dH2VOb');
                      }"
                      class="campo"
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      :disabled="opc_mcdo ==3 || disabled"
                      :value="formatNumber(fila.pcH2VOb)"
                      @input="event => {
                        const val = event.target.value.replace(',', '.');
                        fila.pcH2VOb = Number(val);
                        validarCampo(fila, 'pcH2VOb');
                      }"
                      class="campo"
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      :disabled="opc_mcdo ==3 || disabled"
                      :value="formatNumber(fila.dH2VOp)"
                      @input="event => {
                        const val = event.target.value.replace(',', '.');
                        fila.dH2VOp = Number(val);
                        validarCampo(fila, 'dH2VOp');
                      }"
                      class="campo"
                    />
                  </td>

                  <td>
                    <input
                      type="text"
                      :disabled="opc_mcdo ==3|| disabled"
                      :value="formatNumber(fila.pcH2VOp)"
                      @input="event => {
                        const val = event.target.value.replace(',', '.');
                        fila.pcH2VOp = Number(val);
                        validarCampo(fila, 'pcH2VOp');
                      }"
                      class="campo"
                    />
                  </td>
                </tr>
              </tbody>
                  </table>
                </div>

                </v-col>
                </v-row>
        </v-card-text>
    </v-card>


</template>

<script>
//import VGrid from "@revolist/vue3-datagrid";
//import axios from 'axios';
//import store from '../store';
//import ComponenteLoading from './ComponenteLoading.vue';
//import {ref} from "vue";
export default {

  props: {
    modelValue: {
      type: Array,
      required: true,
    },
    demanda_lc:{
      type:Array,
      required:true,
    },
    opc_mcdo:{
      type:Number,
      required:true,
    },
    disabled:{
      type:Boolean,
      default:false,
    },
    infl:{
      type: Object,
      required:true
    },
    datos_generales:{
      type:Object,
      required:true,
    },

    ejecucion:{
      type:Object,
       default: () => ({})
    },
    name:{
      type:String,
      default:()=> ("")
    }
  },

  data() {
    return {
      
      loading: false,
      anio_min:2025,
      anio_max:2100,
      first_index:0,
      last_index:50,
      columns: [
        { name: this.$t('simulacion.modulo.demanda.tabla.id'),  prop: "id", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.demanda.tabla.dH2Ob'),  prop: "dH2VOb", size: 250  },
        { name: this.$t('simulacion.modulo.demanda.tabla.pcH2Ob'),  prop: "pcH2VOb", size: 300  },
        { name: this.$t('simulacion.modulo.demanda.tabla.dH2Op'),  prop: "dH2VOp", size: 250  },
        { name: this.$t('simulacion.modulo.demanda.tabla.pcH2Op'),  prop: "pcH2VOp", size: 250  },
      ],

     /*  columns_lc: [
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.id'),  prop: "id", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.dH2Ob'),  prop: "dH2VOb", size: 250  },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.pcH2Ob'),  prop: "pcH2VOb", size: 300  },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.dH2Op'),  prop: "dH2VOp", size: 250  },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.pcH2Op'),  prop: "pcH2VOp", size: 250  },
      ], */

      columnasEsperadas:{
      id: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.id, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.anio],
      dH2VOb: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.dH2Ob, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.dH2Ob],
      pcH2VOb: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.pcH2Ob,this.$i18n.messages.en.simulacion.modulo.demanda.tabla.pcH2Ob],
      dH2VOp: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.dH2Op, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.dH2Op],
      pcH2VOp: [this.$i18n.messages.es.simulacion.modulo.demanda.tabla.pcH2Op, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.pcH2Op],
    
    },
    /* columnasEsperadasLC:{
      id: [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.id, this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.anio],
      dH2VOb: [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.dH2Ob, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.dH2Ob],
      pcH2VOb: [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.pcH2Ob,this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.pcH2Ob],
      dH2VOp: [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.dH2Op, this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.dH2Op],
      pcH2VOp: [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.pcH2Op, this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.pcH2Op],
    
    }, */

      datos: [...this.modelValue],
      datos_lc:[...this.demanda_lc],
     /*  local_infl:{...this.infl}, */

      rules: {
        required: (v) => !!v || "Este campo es obligatorio",
        minYear: (value) => value >= this.min_year || `El año debe ser mayor o igual a ${this.min_year}`,
         Negativo: (v) => {
        const num = Number(v.toString().replace(',', '.'));
          return isNaN(num) ? 'Valor inválido' : (num >= 0 ? true : 'El valor no puede ser negativo');
        },
      },
    };
  },

  components: {
    //VGrid,
    //ComponenteLoading,
  },

  watch: {
    datos_generales:{
      handler(){
        console.log("Actualizado ANIO INICIO"),
      this.first_index=this.datos_generales.anio_inicio-this.anio_min
      this.last_index=this.datos_generales.anio_fin-this.anio_min+1
      }
      
    //this.actualizarAnios();
    },

    local_infl:{
      handler(newDatos) {        
        this.$emit('update:infl', newDatos);
      },      
      immediate: true,
      deep: true,
    },
    '$i18n.locale'() {     
      
      this.columns = [
        { name: this.$t('simulacion.modulo.demanda.tabla.id'),  prop: "id", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.demanda.tabla.dH2Ob'),  prop: "dH2VOb", size: 250  },
        { name: this.$t('simulacion.modulo.demanda.tabla.pcH2Ob'),  prop: "pcH2VOb", size: 300  },
        { name: this.$t('simulacion.modulo.demanda.tabla.dH2Op'),  prop: "dH2VOp", size: 250  },
        { name: this.$t('simulacion.modulo.demanda.tabla.pcH2Op'),  prop: "pcH2VOp", size: 250  },
      ];

      /* this.columns_lc= [
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.id'),  prop: "id", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.dH2Ob'),  prop: "dH2VOb", size: 350  },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.pcH2Ob'),  prop: "pcH2VOb", size: 300  },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.dH2Op'),  prop: "dH2VOp", size: 250  },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.pcH2Op'),  prop: "pcH2VOp", size: 250  },
      ] */

    },
    modelValue(newVal) {
    this.datos = [...newVal]; // O con deep clone si es necesario
    },
    demanda_lc(newVal) {
      this.datos_lc = [...newVal]; // O con deep clone si es necesario
    },



  },
computed:{
    local_ejecucion: {
      get(){
        return {...this.ejecucion}
      },
      set(value){
        console.log("Seteando valores: ", value)
        this.$emit('update:ejecucion', value);
      },  
      immediate: true,
      deep: true,
      
    },
    opc_lcohlc: {
    get() {
      return this.ejecucion.OPC_LCOHLC;
    },
    set(value) {
         this.$emit('update:ejecucion', { 
        ...this.ejecucion, 
          OPC_LCOHLC: value 
        });
        if (value === 0) {
          this.onActivar()
        } else if (value === 1) {
          this.onDesactivar()
        }
    }
  },
    
    
    
    columnasEsperadasLC:{
      get(){
        let base={
            id: [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.id, this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.anio],
            dH2VOb: [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.dH2Ob, this.$i18n.messages.en.simulacion.modulo.demanda.tabla.dH2Ob],
            pcH2VOb: [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.pcH2Ob,this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.pcH2Ob],
        }
         if(this.opc_lcohlc==0){
          base["dH2VOp"]=[this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.dmH2Oex, this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.dmH2Oex]
          base["pcH2VOp"]=[this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.pcH2Oex, this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.pcH2Oex]
         }
         else{
           base["dH2VOp"]=[this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.dH2Op, this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.dH2Op]
        base["pcH2VOp"]= [this.$i18n.messages.es.simulacion.modulo.demanda_lc.tabla.pcH2Op, this.$i18n.messages.en.simulacion.modulo.demanda_lc.tabla.pcH2Op]
         }

        
        return base
      }
    },
      
columns_lc:{
  get(){
    let base=[
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.id'),  prop: "id", size: 90, readonly: true },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.dH2Ob'),  prop: "dH2VOb", size: 250  },
        { name: this.$t('simulacion.modulo.demanda_lc.tabla.pcH2Ob'),  prop: "pcH2VOb", size: 300  },
    ]
    let extra=[]
    if(this.opc_lcohlc==0){
      extra=[
         { name: this.$t('simulacion.modulo.demanda_lc.tabla.dmH2Oex'),  prop: "dH2VOp", size: 250  },
         { name: this.$t('simulacion.modulo.demanda_lc.tabla.pcH2Oex'),  prop: "pcH2VOp", size: 250  }
       ]  
    }
    else{
      extra=[
         { name: this.$t('simulacion.modulo.demanda_lc.tabla.dH2Op'),  prop: "dH2VOp", size: 250  },
         { name: this.$t('simulacion.modulo.demanda_lc.tabla.pcH2Op'),  prop: "pcH2VOp", size: 250  }
        ]
    }
    base= [... base,
      ...extra
      ]
    return base
  }
},

  local_infl: {
    get() {
      return this.infl;
    },
    set(newDatos) {
        console.log("Set de local_infl", newDatos)
      /* this.$emit('update:infl', newDatos); */
    }
  },
  INFL: {
      get() {        
        const value = this.local_infl.inflacion  
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.local_infl.inflacion = isNaN(numericValue) ? 0 : numericValue;
      },
    },
    INFL_formatted: {
    get() {
      return this.formatNumber(this.INFL);
    },
    set(val) {
      const numeric = val.replace(',', '.');
      this.INFL = Number(numeric);
    }
    }
},
methods: {

  handleSwitchChange(){
    console.log("handleSwitchChange value: ", this.opc_lcohlc)
    if (this.opc_lcohlc===0){
      this.onActivar()
    }
    else if(this.opc_lcohlc===1){
      this.onDesactivar()
    }
  },
   onActivar(){
      console.log("Activando")
        console.log("Activar mensual")
        this.demanda_lc.forEach(item => {
            item.dH2VOp = 100000;
          });
       
    },
    onDesactivar(){
        console.log("Desactivando")
        this.demanda_lc.forEach(item => {
            item.dH2VOp = 0;
          });
  
      
    },
  //Activar demanda opcional en cálculo LCOH, todos los valores a 100000
  activarDemandaOpcionalLCOH(){
    console.log("Activado")
  },
  desactivarDemandaOpcionalLCOH(){
    console.log("Activado")
  },

  formatNumber(value) {
  if (value === null || value === undefined || value === '') return '';
  if (typeof value !== 'number') value = Number(value);

  if (Number.isInteger(value)) {
    return value.toString().replace('.', ',');
  } else {
    return value.toString().replace('.', ',');
  }
},
  calcularInflacion(){
    console.log("inflacion: ",this.infl.inflacion, " ",this.infl.pr_H2VOb, " ",this.infl.pr_H2VOp )
    
    this.$emit('inflacion','Calcular_inflacion')
  },
  
  actualizarAnios(){
    const anio_inicio=this.datos_generales.anio_inicio;
    const anio_fin=this.datos_generales.anio_fin;
    const filtrados = this.modelValue.filter(d => {
      const anio = parseInt(d.id.split('-')[0]); // extrae el año
      return anio >= anio_inicio && anio <= anio_fin;
    });
    this.datos=[...filtrados]

    this.$emit("update:modelValue", this.datos);

    const filtradoslc = this.demanda_lc.filter(d => {
      const anio = parseInt(d.id.split('-')[0]); // extrae el año
      return anio >= anio_inicio && anio <= anio_fin;
    });
    this.datos_lc=[...filtradoslc]
 
    this.$emit("update:demanda_lc", this.datos_lc);
  },
    handleCellEdit(event) {
      
      console.log("Intercepta...");

      // Acceder al detalle del evento
      const { detail } = event;

      // Convertir a número si la columna es "valor"
      if (detail.prop === "valor") {
        const newValue = Number(detail.val);

        // Actualizar el modelo de la fila correspondiente
        const rowIndex = detail.rowIndex;
        this.datos[rowIndex][detail.prop] = newValue;

        // Confirmación en consola
        console.log(`Fila actualizada (${rowIndex}):`, this.datos[rowIndex]);
      }
    },


    exportToCSV() {
      const headers = this.columns.map((col) => col.name).join(";");
      
      const rows = this.datos.filter(d => {
                      const partes = d.id.split('-');
                    const anio = parseInt(partes[0]);
                    let mes = parseInt(partes[1]);
                    //Si no existe el mes en las partes separadas, se asigna a 1 para que el modo anual funcione tambien
                    const anioInicio = this.datos_generales.anio_inicio;
                    const anioFin = this.datos_generales.anio_fin;
                    const mesInicio = this.datos_generales.mes_inicio;

                    // Filtra por año dentro del rango
                    if (anio < anioInicio || anio > anioFin) return false;
                    if (mes){
                      
                      // Si es el primer año, aplica también el filtro de mes
                      if (anio === anioInicio && mes < mesInicio) return false;
                      
                      // Si es el íltimo año, aplica el filtro del mes a la inversa
                      if (anioInicio!=anioFin &&  anio === anioFin && ( mesInicio!=1 && mes >= mesInicio)) return false;
                    }
                    return true;
                  }).map((row) =>
        this.columns.map((col) => 
                  {
                    //Id es la columna fecha
                    if (col.prop === 'id') { 
                    return row[col.prop] || ""; 
                  } else {
                    return this.formatNumber(row[col.prop]) || "";
                  }
                  }
      
      ).join(";")
      );

      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;

      let nombre =  this.$t('simulacion.modulo.demanda.titulo')+"_"+this.$t('simulacion.modulo.demanda.subtitulo');
      nombre = nombre.toLowerCase().replace(/ /g, '_');
      //Para quitar tildes
      nombre=nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      a.download = nombre+".csv";
      a.click();
      URL.revokeObjectURL(url);
    },
    exportToCSVLC() {
      const headers = this.columns_lc.map((col) => col.name).join(";");
      const rows = this.datos_lc.filter(d => {
        const partes = d.id.split('-');
                    const anio = parseInt(partes[0]);
                    let mes = parseInt(partes[1]);
                    const anioInicio = this.datos_generales.anio_inicio;
                    const anioFin = this.datos_generales.anio_fin;
                    const mesInicio = this.datos_generales.mes_inicio;
                    // Filtra por año dentro del rango
                    if (anio < anioInicio || anio > anioFin) return false;
                    if (mes){
                      // Si es el primer año, aplica también el filtro de mes
                      if (anio === anioInicio && mes < mesInicio) return false;
                      
                      // Si es el íltimo año, aplica el filtro del mes a la inversa
                      if (anioInicio!=anioFin &&  anio === anioFin && ( mesInicio!=1 && mes >= mesInicio)) return false;
                    }
                    return true;
                  }).map((row) =>
        this.columns.map((col) => 
                  {
                    if (col.prop === 'id') { 
                    return row[col.prop] || ""; 
                  } else {
                    return this.formatNumber(row[col.prop]) || "";
                  }
                  }
      
      ).join(";")
      );
      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      let nombre =  this.$t('simulacion.modulo.demanda_lc.titulo')+"_"+this.$t('simulacion.modulo.demanda_lc.subtitulo');
      nombre = nombre.toLowerCase().replace(/ /g, '_');
      //Para quitar tildes
      nombre=nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      a.download = nombre+".csv";
      a.click();
      URL.revokeObjectURL(url);
    },
    importFromCSV() {
      this.$refs.fileInput.click();
    },

    importFromCSVLC() {
      this.$refs.fileInputLC.click();
    },

    guess_delimiter(headers) {
      return headers.split(',').length > headers.split(';').length ? ',' : ';';
    },

    verificarClaveEnColumnas(dict, h2Verde){
      let todos=true;
      let columnasEsperadas 
      h2Verde? columnasEsperadas=this.columnasEsperadas : columnasEsperadas=this.columnasEsperadasLC
      // Recorremos el diccionario
      Object.keys(dict).forEach(key => {
        // Buscamos si el valor de la clave del dict está dentro de los arrays de columnasEsperadas
        const coincidencia = Object.keys(columnasEsperadas).some(columna => {
          return columnasEsperadas[columna].some(valor => valor.includes(dict[key].toLowerCase().trim()));
        });

        if (coincidencia) {
          console.log(`La clave "${key}" se encuentra en las columnas esperadas`);
          
        } else {
          console.log(`La clave "${key}" NO se encuentra en las columnas esperadas`);
        }
        todos=todos & coincidencia
      });
      return todos
    },
    devolverPropColumnas(str, h2Verde){
      let columnasEsperadas 
      h2Verde? columnasEsperadas=this.columnasEsperadas : columnasEsperadas=this.columnasEsperadasLC
      const propEntry =Object.entries(columnasEsperadas).find(([,value ])=> {
        //console.log("Entrada de columnasEsperadas. Key: ", key , " Value:", value)
        //console.log("Value ", key," ",value.join(',') , "Se busca ", str)
        // Buscamos si el valor de la clave del dict está dentro de los arrays de columnasEsperadas
        if (value.some(v => v ==str)) {
          //console.log(`Coincide con la clave: ${key}`);
          return true
        }
        });
        const prop = propEntry ? propEntry[0] : null;
        //console.log("Prop: ", prop);
        return prop;

    },
    //Función para revisar que las cabeceras están en el csv
    revisarCabeceras(header, h2Verde){
      let cabecerasFaltantes=[]
      header.forEach(value=>{
        //console.log("Valores de header: ", value)
        if(!this.devolverPropColumnas(value,h2Verde)){
        
          cabecerasFaltantes.push(value)
        }
      })
      console.log("Cabeceras faltantes: ", cabecerasFaltantes)
      //SI existen valores que faltan
      if(cabecerasFaltantes.length>0){
        //codigo de aviso:
        alert( this.$t('mensajes.alerta_cabeceras') +" "+ cabecerasFaltantes.join(', '))
        return true;
      }
      else{
        return false;
      }
    },

    handleCSVUpload(event) {
      const file = event.target.files[0];
      if (file) {
        
        const reader = new FileReader();
        reader.onload = (e) => {
          const csvData = e.target.result;
          const [headerLine, ...lines] = csvData
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0); // Eliminar líneas vacías
          //console.log("Datos de csv: ", csvData.split('\n')[0])
          const delim = this.guess_delimiter(csvData.split('\n')[0])
          console.log("Delimitador: ", delim)
          //console.log("headerline: ", headerLine)
          const header=headerLine.split(delim);
          //Revisar que las cabeceras estén bien, este es hidrógeno verde
          if( this.revisarCabeceras(header,true)){
            return
          }
          //console.log("Lines : ", lines)
          const nuevaLista = lines.map(obj => {
          const values = obj.split(";");
          const newobj = {};
          
          header.forEach((header, index) => {
              const value = values[index];
              //console.log("Value a asignar: ", value)
              // Convertir a número si el valor parece numérico
              const prop = this.devolverPropColumnas(header,true)
              if(prop=="id"){
                // Revisar si tiene formato de dia-mes-año
                const formatoDiaMesAnio = /^\d{2}\/\d{2}\/\d{4}$/;
                newobj[prop] = formatoDiaMesAnio.test(value)
                  ? (() => {
                      const [dd, mm, yyyy] = value.split("/");
                      return `${yyyy}-${mm}-${dd}`;
                    })()
                  : value;
              }
              else{
                 const cleanValue = value?.replace(',', '.');
                 newobj[prop] = cleanValue === "" || isNaN(cleanValue) ? value : Number(cleanValue);
              }
             
            });
            return newobj;

          /* Object.entries(obj).forEach((clave, valor) => {
            console.log("Entradas de lines -> ", clave , ' --- ', valor)
            const nuevaClave = 3//this.devolverPropColumnas(clave) || clave; // Usa nueva clave si existe
            nuevoObj[nuevaClave] = valor;
          });
          return nuevoObj; */
        });
        //console.log("nuevaLista: ", nuevaLista)
        // Convertimos updatedData a un Map para acceso rápido por año
        const updatedMap = new Map(nuevaLista.map(item => [item.id, item]));
        const filteredMap = new Map(
            [...updatedMap.entries()].filter(([id]) => {

              //Obtener el año del id, ya sea:
              //SOlo el año : 2025
              // Año y mes: 2025-01
              // Año, mes y dia (previamente parseado) 2025-01-12
              const year = parseInt(id.substring(0, 4), 10);


              //console.log("Año: ", year, " id: ", id);
              return year >= this.anio_min && year <= this.anio_max;
            })
          );

        //console.log("updatedMap : ", updatedMap)
        
        const mergedData = this.datos.map(item =>
        filteredMap.has(item.id) ? filteredMap.get(item.id) : (/* console.log("No tiene ", item.id, " ", typeof(item.id)) ,*/ item)
        );
          this.datos = [...mergedData];
          //console.log("Merged data: ", mergedData)
          this.$emit("update:modelValue", this.datos);
          console.log(this.datos);
        };
        reader.readAsText(file, "UTF-8");
      }
      event.target.value = ""; // Reinicia el valor del input para permitir el mismo archivo
    },

    handleCSVUploadLC(event) {
      const file = event.target.files[0];
      if (file) {
        
        const reader = new FileReader();
        reader.onload = (e) => {
          const csvData = e.target.result;
          const [headerLine, ...lines] = csvData
            .split("\n")
            .map((line) => line.trim())
            .filter((line) => line.length > 0); // Eliminar líneas vacías
          //console.log("Datos de csv: ", csvData.split('\n')[0])
          const delim = this.guess_delimiter(csvData.split('\n')[0])
          console.log("Delimitador: ", delim)
          //console.log("headerline: ", headerLine)
          const header=headerLine.split(delim);
          //Revisar que las cabeceras estén bien, este es hidrógeno verde
          if( this.revisarCabeceras(header,false)){
            return
          }
          //console.log("Lines : ", lines)
          const nuevaLista = lines.map(obj => {
          const values = obj.split(";");
          const newobj = {};
          
          header.forEach((header, index) => {
              const value = values[index];
              //console.log("Value a asignar: ", value)
              // Convertir a número si el valor parece numérico
              const prop = this.devolverPropColumnas(header,false)
              if(prop=="id"){
                // Revisar si tiene formato de dia-mes-año
                const formatoDiaMesAnio = /^\d{2}\/\d{2}\/\d{4}$/;
                newobj[prop] = formatoDiaMesAnio.test(value)
                  ? (() => {
                      const [dd, mm, yyyy] = value.split("/");
                      return `${yyyy}-${mm}-${dd}`;
                    })()
                  : value;
              }
              else{
                 const cleanValue = value?.replace(',', '.');
                 newobj[prop] = cleanValue === "" || isNaN(cleanValue) ? value : Number(cleanValue);
              }
             
            });
            return newobj;

          /* Object.entries(obj).forEach((clave, valor) => {
            console.log("Entradas de lines -> ", clave , ' --- ', valor)
            const nuevaClave = 3//this.devolverPropColumnas(clave) || clave; // Usa nueva clave si existe
            nuevoObj[nuevaClave] = valor;
          });
          return nuevoObj; */
        });
        //console.log("nuevaLista: ", nuevaLista)
        // Convertimos updatedData a un Map para acceso rápido por año
        const updatedMap = new Map(nuevaLista.map(item => [item.id, item]));
        const filteredMap = new Map(
          [...updatedMap.entries()].filter(([id]) => {

            //Obtener el año del id, ya sea:
            //SOlo el año : 2025
            // Año y mes: 2025-01
            // Año, mes y dia (previamente parseado) 2025-01-12
            const year = parseInt(id.substring(0, 4), 10);


            //console.log("Año: ", year, " id: ", id);
            return year >= this.anio_min && year <= this.anio_max;
            })
            );
        console.log("updatedMap : ", updatedMap)
        
        const mergedData = this.datos_lc.map(item =>
        filteredMap.has(item.id) ? filteredMap.get(item.id) : (/* console.log("No tiene ", item.id, " ", typeof(item.id)), */ item)
        );
          this.datos_lc = [...mergedData];
          //console.log("Merged data: ", mergedData)
          this.$emit("update:demanda_lc", this.datos_lc);
         // console.log(this.datos_lc);
        };
        reader.readAsText(file, "UTF-8");
      }
      event.target.value = ""; // Reinicia el valor del input para permitir el mismo archivo
    },

    validarCampo(fila, campo) {
      if (fila[campo] < 0) {
        fila[campo] = 0;
        alert(this.$t('El valor no puede ser negativo'));
      }
    }




  },




};
</script>

<style>
#app2 {
  height: 400px;
  width: 100%;
}
revo-grid {
  height: 100%;
  width: 100%;
  font-size: 12px;
}
.contenedor-limitado{
  width: 100%;
  max-width: 80%;
  margin: 0 auto; /* Opcional: para centrar horizontalmente */
}

.tabla-container {
  max-width: 100%;
  overflow-x: auto;
  margin-top: 20px;
}

.tabla-estilizada {
  width: 100%;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  font-size: 14px;
}

.tabla-estilizada th,
.tabla-estilizada td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.tabla-estilizada th {
  background-color: #0078D4;
  font-weight: bold;
  color: white;
}

.tabla-estilizada tr:nth-child(even) {
  background-color: #eef6ff;
}

.tabla-estilizada tr:hover {
  background-color: #8bb6e7;
}




/*
#eef6ff
#bfddf5

*/
.campo,
.select-binario {
  width: 90%;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 13px;
}
.scroll-container {
  width: 100%;
  height: 100%;
  max-height: calc(100vh - 200px); 
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid #D9D9D9;
  display: flex;
  flex-direction: column;
}
</style>

